import { render, staticRenderFns } from "./OwnedEarnedUniquePostReach.vue?vue&type=template&id=a86fda44&scoped=true&"
import script from "./OwnedEarnedUniquePostReach.vue?vue&type=script&lang=js&"
export * from "./OwnedEarnedUniquePostReach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86fda44",
  null
  
)

export default component.exports